'use client';

import { useLinkStatus } from 'next/link';
import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

const LoadingContext = createContext<{
	setLoading: (isLoading: boolean) => void;
} | null>(null);

const LoaderProvider = ({ children }: { children: ReactNode }) => {
	const [loading, setLoading] = useState<boolean>(false);
	const value = useMemo(() => ({ setLoading }), []);
	return (
		<LoadingContext.Provider value={value}>
			{children}
			{loading && (
				<div className="z-100 pointer-events-none fixed left-0 top-0 flex h-screen w-screen items-center justify-center bg-white/50">
					<span className="loader" />
				</div>
			)}
		</LoadingContext.Provider>
	);
};

export const LoadingHandler = () => {
	const ctx = useContext(LoadingContext);
	const { pending } = useLinkStatus();
	if (!ctx) throw new Error('LoadingHandler must be used within <LoadingProvider>');

	useEffect(() => {
		ctx.setLoading(pending);
		return () => ctx.setLoading(false); // на всякий случай при размонтировании
	}, [pending, ctx]);

	return null;
};

export default LoaderProvider;
